import Event from '../../core/Event';

export default class OrderDraftSaveRequested extends Event {
    public static type = 'OrderDraftSaveRequested';

    constructor() {
        super(OrderDraftSaveRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDraftSaveRequested.ts